import React from 'react'
import { ModalBase, IModalBaseProps, MODAL_TYPES } from 'transfix-ui/components/Modals'
import { Box, makeStyles, Typography } from 'transfix-ui/core'

interface IBuilderWarningsModalProps extends Omit<IModalBaseProps, 'modalType'> {
  builderName: string | undefined
  builderWarnings: string[]
  onCancel: () => void
}

const useBuilderWarningsModalStyles = makeStyles({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
})

export const BuilderWarningsModal = ({
  builderName,
  builderWarnings,
  onCancel,
  open = true,
  ...props
}: IBuilderWarningsModalProps) => {
  const classes = useBuilderWarningsModalStyles()
  const defaultActions: IModalBaseProps['actions'] = [
    {
      label: 'Close',
      action: () => {
        onCancel()
      },
      type: 'dismiss',
      dataTest: 'close-button',
    },
  ]

  return (
    <ModalBase
      dataTest='BuilderWarningsModal'
      modalType={MODAL_TYPES.form}
      size={6}
      open={open}
      actions={defaultActions}
      {...props}>
      <Box>
        <Box className={classes.header}>
          <Typography variant='h3'>Warnings For {builderName} Builder</Typography>
        </Box>

        {builderWarnings.length === 0 ? (
          <Typography variant='h4'>No existing warnings for this builder.</Typography>
        ) : (
          <Box>
            {builderWarnings.map((builderWarning: string) => (
              <Box
                mt={2}
                padding={2}
                display='flex'
                flexDirection='row'
                flexWrap='wrap'
                alignItems='center'
                key={builderWarning}
                justifyContent='space-between'>
                <Typography variant='h4'>{builderWarning}</Typography>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </ModalBase>
  )
}
